<script>
	import { getContext, onDestroy, onMount } from 'svelte'
	import { styles } from '../../library/scripts/styles'
	import { get_element_tags, php_handler } from '../builderUtils'
	import {
		storeElementID,
		storeSelectedTool,
		storeShowTools,
		storeData,
		storeShowGallery,
		storeContact,
		storeBooking,
		storeUpdateSingle,
		storeUpdateContact,
		storeFinishedContent,
		storeShowFinishedBlocks,
		storeLinked,
		storeHM,
		storeUsedColors,
		storeShowDrinks,
		storeShowFoods,
	} from '../../library/scripts/Store.svelte'
	import SiteTool from './SiteTool.svelte'
	import GalleryTool from './GalleryTool.svelte'
	import GalleryModalTool from './GalleryModalTool.svelte'
	import FontTool from './FontTool.svelte'
	import ColumnTool from './ColumnTool.svelte'
	import BlockTool from './BlockTool.svelte'
	import ImageTool from './ImageTool.svelte'
	import SliderTool from './SliderTool.svelte'
	import SingleImageBlockTool from './SingleImageBlockTool.svelte'
	import NavbarTool from './NavbarTool.svelte'
	import ContactTool from './ContactTool.svelte'
	import RoomsTool from './RoomsTool.svelte'
	import MenuTool from './MenuTool.svelte'
	import ShopTool from './ContactTool.svelte'
	import BookingTool from './BookingTool.svelte'
	import Shader from '../../library/ShadersAndSpinners/Shader.svelte'
	import Alert from '../../modals/Alert.svelte'

	export let parentWidth

	let exError = false

	$: elementWidth = parentWidth + 'px'

	let elementID, blockID, columnID, elementTags
	let showSiteTool = false
	let showGalleryTool = false
	let showGalleryModalTool = false
	let showFontTool = false
	let showColumnTool = false
	let showBlockTool = false
	let showImageTool = false
	let showSliderTool = false
	let showSingleImageBlockTool = false
	let showNavbarTool = false
	let showContactTool = false
	let showRoomsTool = false
	let showDrinksTool = false
	let showFoodsTool = false
	let showShopTool = false
	let showBookingTool = false

	// usedColors
	let usedColors = []

	let selectedTool
	const stoSelectedTool = storeSelectedTool.subscribe((value) => {
		selectedTool = value
	})

	const stoElementID = storeElementID.subscribe((value) => {
		elementID = value
	})

	const reset_tools = () => {
		showSiteTool = false
		showGalleryTool = false
		showFontTool = false
		showColumnTool = false
		showBlockTool = false
		showSliderTool = false
		showNavbarTool = false
		showContactTool = false
		showGalleryModalTool = false
		showRoomsTool = false
		showDrinksTool = false
		showFoodsTool = false
		showShopTool = false
		showBookingTool = false
		showImageTool = false
		showSingleImageBlockTool = false
		return true
	}

	$: if (elementID !== '--') {
		const tagValues = get_element_tags(elementID)
		blockID = tagValues[0]
		columnID = tagValues[1]
		elementTags = tagValues[2]

		//site tool
		if (blockID === 'Site') {
			const reset = reset_tools()
			if (reset) showSiteTool = true
			showSiteTool = true
		}

		if (blockID === 'Navbar') {
			const reset = reset_tools()

			if (reset) {
				const to = setTimeout(() => {
					showNavbarTool = true
					clearTimeout(to)
				}, 1000)
			}
		}

		if (blockID === 'gallery') {
			const reset = reset_tools()
			if (reset) showGalleryTool = true
		}
		//show modal tool
		if (selectedTool === 'GalleryModal') {
			const reset = reset_tools()
			if (reset) showGalleryModalTool = true
		}

		//show font tool for block title
		if (elementTags === 'BlockTitle') {
			const reset = reset_tools()
			if (reset) showFontTool = true
		}

		//show cover-slider tool
		if (blockID === 'cover-slider') {
			const reset = reset_tools()
			if (reset) showSliderTool = true
		}

		//show contact tool
		if (blockID === 'contact') {
			const reset = reset_tools()
			if (reset) showContactTool = true
		}

		if (blockID === 'drinks' || blockID === 'foods') {
			const reset = reset_tools()
			if (reset) showDrinksTool = true
		}

		//rooms
		if (blockID === 'rooms') {
			const reset = reset_tools()
			if (reset) showRoomsTool = true
		}

		if (blockID === 'booking') {
			const reset = reset_tools()
			if (reset) showBookingTool = true
		}

		//show block tool
		if (
			blockID.indexOf('Block') > -1 &&
			(!columnID || columnID === '' || columnID === '--' || columnID !== 'singleImageBlock') &&
			elementTags !== 'BlockTitle'
		) {
			const reset = reset_tools()
			if (reset) showBlockTool = true
		}

		//show single image block tool
		if (blockID.indexOf('Block') > -1 && columnID === 'singleImageBlock') {
			const reset = reset_tools()
			if (reset) showSingleImageBlockTool = true
		}

		//show column tool
		if (elementTags.indexOf('Column') > -1 && elementTags.indexOf('Text') < 0 && elementTags.indexOf('Title') < 0) {
			const reset = reset_tools()
			if (reset) showColumnTool = true
		}

		//show font tool
		if (elementTags.indexOf('Title') > -1) {
			const reset = reset_tools()
			if (reset) showFontTool = true
		} else if (elementTags.indexOf('Text') > -1) {
			const reset = reset_tools()
			if (reset) showFontTool = true
		}

		//show image tool
		else if (elementTags.indexOf('Image') > -1) {
			const reset = reset_tools()
			if (reset) {
				let tO = setTimeout(() => {
					showImageTool = true
					clearTimeout(tO)
				}, 600)
			}
		}
	}

	const globals = getContext('globals')
	const colorMain = globals.colorMain
	const fsXS = globals.fsXS
	const fsS = globals.fsS
	const colorError = globals.colorError
	const dark = globals.colorDark
	const light = globals.buttonBgHover
	const navHeight = globals.navHeight
	let saveText = 'save'

	const close_tool = () => {
		const toSave = setTimeout(() => {
			document.getElementById('save').style.backgroundColor = 'blue'
			saveText = 'save'

			storeShowTools.set(false)
			storeHM.set(false)
			document.getElementById('tools').style.width = '0vw'
			const bB = document.getElementById('builderBlock')
			if (bB) {
				document.getElementById('builderBlock').style.width = '100vw'
			}

			document.getElementById('navbar').style.width = '100vw'
			clearTimeout(toSave)
		}, 100)
	}

	const save_content = async () => {
		let configFile
		const stoData = storeData.subscribe((value) => {
			if (value) configFile = value
		})

		const response = await php_handler('updateconfig', configFile)
		if (response) {
			const regex = /hsla[(]{1}/
			// usedColors.push(configFile.body, configFile.caretColor, configFile.caretHover)
			configFile.blocks.forEach((block) => {
				Object.keys(block).forEach((key) => {
					if (typeof block[key] === 'string' && block[key].match(regex)) {
						// replace empty spaces between hsl numbers
						let color = block[key].replace(/\s/, '')
						color = color.replace(/\s/, '')
						if (!usedColors.includes(color)) usedColors.push(color)
					}
				})
			})
			storeUsedColors.set(usedColors)
			document.getElementById('save').style.backgroundColor = 'green'
			saveText = 'saving'
			const toSave = setTimeout(() => {
				document.getElementById('save').style.backgroundColor = 'blue'
				saveText = 'save'

				storeShowTools.set(false)
				document.getElementById('tools').style.width = '0vw'
				const bB = document.getElementById('builderBlock')
				if (bB) {
					document.getElementById('builderBlock').style.width = '100vw'
				}

				document.getElementById('navbar').style.width = '100vw'
				storeHM.set(false)
				clearTimeout(toSave)
			}, 2000)
		}
		storeShowGallery.set(false)
		storeSelectedTool.set('--')
		storeContact.set(false)
		stoData
	}

	//update block content
	const update = () => {
		storeUpdateSingle.set(blockID)
		storeHM.set(false)

		// include this blockID in close popups
		const closePops = ['Contact', 'booking', 'drinks', 'foods']

		if (closePops.includes(blockID)) {
			if (blockID === 'Contact') storeUpdateContact.set(true)
			storeContact.set(false)
			storeBooking.set(false)
			storeShowDrinks.set(false)
			storeShowFoods.set(false)
			const toClose = setTimeout(() => {
				document.location = '#/createblock'
				clearTimeout(toClose)
			}, 500)
		} else {
			storeFinishedContent.set({ finishedBlocks: [blockID], linkedSites: $storeLinked.linkedSites })
			const toClose = setTimeout(() => {
				storeShowFinishedBlocks.set(true)
				document.location = '#/createblock'
				clearTimeout(toClose)
			}, 500)
		}
	}

	//close the error modal
	const close_alert = () => {
		exError = false
	}

	onMount(() => {
		document.getElementById('tool_main').style.width = elementWidth
	})

	onDestroy(() => {
		stoElementID
		stoSelectedTool
	})
</script>

<main id="tool_main" use:styles={{ elementWidth }} use:styles={{ navHeight }}>
	<div class="title_container">
		<div class="bar_title" use:styles={{ fsS, colorMain }}>Toolbar</div>
	</div>

	<div class="selection" use:styles={{ fsXS, colorError }}>
		{blockID} -- {elementTags}
	</div>
	<div class="tools_container">
		{#if showSiteTool}
			<SiteTool width={elementWidth} />
		{:else if showNavbarTool}
			<NavbarTool width={elementWidth} />
		{:else if showGalleryTool}
			<GalleryTool width={elementWidth} />
		{:else if showSliderTool}
			<SliderTool width={elementWidth} />
		{:else if showFontTool}
			<FontTool width={elementWidth} />
		{:else if showColumnTool}
			<ColumnTool width={elementWidth} />
		{:else if showBlockTool}
			<BlockTool width={elementWidth} />
		{:else if showSingleImageBlockTool}
			<SingleImageBlockTool width={elementWidth} />
		{:else if showImageTool}
			<ImageTool width={elementWidth} />
		{:else if showContactTool}
			<ContactTool width={elementWidth} />
		{:else if showGalleryModalTool}
			<GalleryModalTool width={elementWidth} />
		{:else if showDrinksTool}
			<MenuTool width={elementWidth} />
		{:else if showFoodsTool}
			<MenuTool width={elementWidth} />
		{:else if showBookingTool}
			<BookingTool width={elementWidth} />
		{:else if showRoomsTool}
			<RoomsTool width={elementWidth} />
		{:else if showShopTool}
			<ShopTool width={elementWidth} />
		{/if}
		<div id="save" class="save" use:styles={{ fsS }} on:click={save_content} on:keydown={save_content}>
			{saveText}
		</div>

		<!-- not for navigation -->
		{#if blockID !== 'Navbar'}
			<div class="save update" use:styles={{ fsS }} on:click={update} on:keydown={update}>update block</div>
		{/if}

		<!-- close tool -->
		<div id="save" class="save update" use:styles={{ fsS }} on:click={close_tool} on:keydown={close_tool}>
			close tool
		</div>
	</div>
</main>

{#if exError}
	<Shader>
		<div slot="content">
			<Alert
				message="NOT REGISTERED"
				message2="This feature only works for registred users!"
				showOkButton={false}
				on:alertclose={close_alert}
			/>
		</div>
	</Shader>
{/if}

<style>
	main {
		position: relative;
		top: 0px;
		width: var(--elementWidth);
		transition: 1ms linear;
		user-select: none;
		height: 100%;
		overflow-y: scroll;
	}

	.title_container {
		position: relative;
		display: flex;
		width: 100%;
		height: clamp(30px, 3.25vw, 50px);
		align-items: center;
	}
	.bar_title {
		position: absolute;
		display: flex;
		align-items: center;
		justify-content: center;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		font-size: var(--fsS);
		font-weight: bold;
		color: var(--colorMain);
		padding: 1%;
		background-color: hsl(0, 0%, 50%);
	}

	.selection {
		display: flex;
		justify-content: center;
		width: 100%;
		font-size: var(--fsXS);
		font-weight: bold;
		color: white;
		padding: 10px;
		background-color: darkred;
		text-transform: uppercase;
	}

	.tools_container {
		display: flex;
		flex-direction: column;
		height: fit-content;
	}

	.save {
		display: flex;
		width: 100%;
		justify-content: center;
		background-color: hsl(243, 96%, 52%);
		font-size: var(--fsS);
		color: white;
		margin-top: 20px;
		margin-bottom: 20px;
		padding: 10px;
		cursor: pointer;
	}

	.save:hover {
		background-color: hsl(243, 96%, 72%);
		color: black;
	}

	.update {
		background-color: darkslategray;
	}

	.update:hover {
		background-color: dimgrey;
	}
</style>
